import { apiClient } from './apiClient';

const createCategory = async (payload) => {
  return await apiClient.post('/category', payload);
};

const fetchCategories = async (payload) => {
  return await apiClient.get('/categories', payload);
};

const updateCategory = async (id, payload) => {
  return await apiClient.patch(`/category/${id}`, payload);
};

const deleteCategory = async (id) => {
  return await apiClient.delete_req(`/category/${id}`);
};

export const categoryApi = {
  createCategory,
  fetchCategories,
  updateCategory,
  deleteCategory
};
